import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'encode'
})
export class EncodePipe implements PipeTransform {

  transform(value: any, ...args: any[]): any {
    console.info(encodeURIComponent(value));
    return encodeURIComponent(value);
  }

}
